var map = {
	"./trix_color": 16,
	"./trix_color.svg": 16,
	"./trix_embed": 17,
	"./trix_embed.svg": 17,
	"./trix_horizontal_rule": 18,
	"./trix_horizontal_rule.svg": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;